import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Container
} from '@app/shared/dynamic-form';

@Injectable()
export class CalculatorJsFormService {
  constructor() {}

  /**
   * Genera los campos del formulario para calcular las operaciones
   *
   * @returns {BaseControl<any>[]}
   * @memberof CalculatorJsFormService
   */
  getFields(): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row',
        order: 1,
        controls: [
          new Textbox({
            key: 'txtOperactionCalculator',
            type: 'text',
            label: 'Operacion:',
            size: 'col-md-6',
            placeholder: 'Ingrese una operacion',
            describe: 'Ingrese una operacion valida para ser calculada.',
            validations: {
              validators: [Validators.required],
              messages: {
                required: 'Para calcular una operacion debe existir una.',
              }
            }
          }),
          new Textbox({
            key: 'txtResult',
            type: 'text',
            label: 'Resultado de la operacion:',
            disabled: true,
            size: 'col-md-6',
            placeholder: 'Resultado de operacion',
          })
        ]
      })
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/calculatorjs/shared/calculatorjs.form.service.ts